import { Image } from "@kobalte/core";
import { styled } from "solid-styled-components";

export const ProgrammeImage = styled(Image.Root)`
  height: 100px;
  aspect-ratio: 1 / 1;
  border-radius: 5px;
  overflow: hidden;
  flex-shrink: 0;
  & > * {
    width: 100%;
    height: 100%;
  }
  @media only screen and (max-width: 512px) {
    height: 60px;
  }
`;
